import { render, staticRenderFns } from "./StandardCardHeader.vue?vue&type=template&id=3f0a1368&"
import script from "./StandardCardHeader.vue?vue&type=script&lang=js&"
export * from "./StandardCardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCardTitle})
